var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4732_19783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77539 4.2752C4.77539 3.85748 4.94133 3.45687 5.2367 3.1615C5.53207 2.86613 5.93267 2.7002 6.35039 2.7002H12.6504C13.0681 2.7002 13.4687 2.86613 13.7641 3.1615C14.0595 3.45687 14.2254 3.85748 14.2254 4.2752V14.9064C14.2254 14.9777 14.206 15.0475 14.1694 15.1086C14.1328 15.1697 14.0803 15.2198 14.0175 15.2534C13.9547 15.287 13.884 15.3029 13.8128 15.2995C13.7417 15.2961 13.6728 15.2735 13.6135 15.234L9.50039 13.0172L5.38728 15.234C5.32798 15.2735 5.2591 15.2961 5.18796 15.2995C5.11681 15.3029 5.04608 15.287 4.98329 15.2534C4.9205 15.2198 4.868 15.1697 4.83139 15.1086C4.79478 15.0475 4.77543 14.9777 4.77539 14.9064V4.2752ZM6.35039 3.4877C6.14153 3.4877 5.94123 3.57066 5.79354 3.71835C5.64586 3.86603 5.56289 4.06634 5.56289 4.2752V14.1709L9.28225 12.2163C9.34688 12.1733 9.42277 12.1504 9.50039 12.1504C9.57801 12.1504 9.65391 12.1733 9.71853 12.2163L13.4379 14.1709V4.2752C13.4379 4.06634 13.3549 3.86603 13.2072 3.71835C13.0596 3.57066 12.8592 3.4877 12.6504 3.4877H6.35039Z",
    fill: "#0194D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4732_19783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6,
    height: 12.6,
    fill: "white",
    transform: "translate(3.2002 2.7002)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.ca36b12d1ee2c0fa1d95e5a731b61232.svg";
export { ForwardRef as ReactComponent };